var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.as,_vm._b({tag:"component",class:['star-border', _vm.customClass],style:(_vm.componentStyle),on:{"click":_vm.handleClick}},'component',_vm.restAttrs,false),[_c('div',{staticClass:"star-effect star-effect-bottom animate-star-movement-bottom",style:({
      background: `radial-gradient(circle, ${_vm.color}, transparent 10%)`,
      animationDuration: _vm.speed
    })}),_c('div',{staticClass:"star-effect star-effect-top animate-star-movement-top",style:({
      background: `radial-gradient(circle, ${_vm.color}, transparent 10%)`,
      animationDuration: _vm.speed
    })}),_c('div',{staticClass:"star-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }